import api, { type ApiResponse } from './api'

export interface MerchantDailyStatsItem {
  dayStart: number
  createdOrderCount: number
  paidOrderCount: number
  flowAmountUsd: string
  unconvertedOrderCount: number
}

export type DashboardWindow = 'all' | '1d' | '7d' | '14d' | '30d' | 'month' | 'custom'
export type DailyStatsQuery = { window: Exclude<DashboardWindow, 'custom'> } | { window: 'custom'; startDate: number; endDate: number }

export interface MerchantDailyStatsSummary {
  flowAmountUsd: string
  createdOrderCount: number
  paidOrderCount: number
  completionRate: string
  averageTicketUsd: string | null
  unconvertedOrderCount: number
}

export interface MerchantPaymentMethodStats extends MerchantDailyStatsSummary {
  paymentMethod: string
}

export interface MerchantDailyStats {
  timezone: string
  currency: 'USD'
  window: DashboardWindow
  startDate: number
  endDate: number
  summary: MerchantDailyStatsSummary
  days: MerchantDailyStatsItem[]
  methods: MerchantPaymentMethodStats[]
}

export function getDailyStats(query: DailyStatsQuery = { window: 'all' }): Promise<ApiResponse<MerchantDailyStats>> {
  return api.get('/v1/merchant/dashboard/daily-stats', { params: query })
}
